// en/channel.js
export const channel = {
  header: {
    title: "Canaux de réservation",
    subtitle: "Synchronisez ou gérez Booking.com, Expedia, Airbnb et bien d'autres.",
  },

  establishedConnections: "Connexions établies",

  common: {
    loading: "Chargement...",
    configure: "Configurer",
    close: "Fermer",
    comingSoon: "Bientôt disponible",
  },

  alerts: {
    bullets: {
      choosePlan: "Choisissez un forfait et activez votre Channel Manager.",
      completeProperty: "Complétez la configuration de votre propriété dans le tableau de bord.",
    },
    title: "Action requise",
    planRequired:
      "Vous devez avoir un forfait actif pour relier votre propriété à une OTA.",
    missingPropertyChannel:
      "Pour vous connecter à une OTA, vous devez d'abord compléter la configuration de votre propriété dans le Channel Manager.",
  },

  modal: {
    channelHeader: "Connexion du canal avec {channel}",
  },

  web: {
    cardTitle: "Réservations web directes",
    // NEW: description for the OTA-style card
    cardDescription:
      "Recevez des réservations directes depuis votre site web sans commissions d'OTA.",
    // NEW: button texts for card and table
    manageCta: "Gérer",
    configureCta: "Configurer",
    // NEW: label for the ID column of the direct bookings row
    directLinkLabel: "Lien de réservation directe",

    linkShareMessage: "Bonjour 👋 Vous pouvez réserver via ce lien :\n\n{link}",
    modalTitle: "Réservations web directes",
    description:
      "Activez ou désactivez les options disponibles pour la réservation directe sur votre site web. Les voyageurs pourront réserver directement sans intermédiaires.",
    toggleAllDesktop: "Activer/Désactiver toutes les réservations web",
    toggleAllMobile: "Activer/Désactiver",
    table: {
      name: "Nom",
      available: "Disponible à la réservation web",
    },
    capacity: "Capacité",
    people: "personnes",
    empty: "Aucun élément trouvé",

    // Link section
    linkTitle: "Votre lien de réservation directe",
    linkHelp: "Partagez ce lien pour que vos voyageurs puissent réserver directement",
    linkCopyTooltip: "Copier le lien",
    linkShareWhatsappTooltip: "Partager sur WhatsApp",
  },

  plan: {
    title: "Activez votre forfait pour vous connecter",
    subtitle:
      "Choisissez le forfait qui correspond à vos besoins et activez la connexion avec Booking, Airbnb, Expedia et plus encore.",
    hint: "Une fois abonné, revenez ici ; nous débloquerons tous les canaux auxquels vous pouvez vous connecter.",
    cta: "Améliorer le forfait",
  },

  toasts: {
    paymentTypeUpdated: "Méthode de paiement mise à jour avec succès",
    linkCopiedTitle: "Copié !",
    linkCopiedBody: "Lien copié avec succès",
    linkCopyErrorTitle: "Erreur",
    linkCopyErrorBody: "Une erreur est survenue lors de la copie du lien",
    save: "Erreur lors de l'enregistrement de la configuration",
    updateWebReservation: "Erreur lors de la mise à jour de la réservation web",
    saved: "Configuration enregistrée avec succès",
    updateWebReservationsGlobal:
      "État global des réservations directes mis à jour avec succès",
  },

  errors: {
    loadData: "Erreur lors du chargement des données. Veuillez réessayer.",
    generateToken: "Erreur lors de la génération du token",
    connectChannel: "Erreur lors de la connexion au canal. Veuillez réessayer.",
    updatePaymentType: "Erreur lors de la mise à jour de la méthode de paiement",
    save: "Erreur lors de l'enregistrement de la configuration",
    updateWebReservation: "Erreur lors de la mise à jour de la réservation web",
  },

  tabs: {
    reservations: "Statut des réservations",
    payments: "Prix et paiements",
    share: "Partager",
  },

  payments: {
    title: "Comment souhaitez-vous recevoir les paiements des réservations directes ?",
    onArrival: {
      label: "Payer sur place",
      desc: "Les voyageurs paieront directement à l'arrivée",
    },
    online: {
      label: "Prépaiement en ligne",
      desc: "Les voyageurs paieront au moment de la réservation",
    },
  },

  discounts: {
    sectionTitle: "Configurer la remise pour les réservations directes",
    toggle: "Appliquer une remise aux réservations directes",
    typeTitle: "Type de remise :",
    percentage: {
      label: "Remise en pourcentage",
      desc: "Appliquer une remise en pourcentage",
    },
    fixed: {
      label: "Remise à prix fixe",
      desc: "Appliquer une remise d'un montant fixe",
    },
    valueTitle: "Valeur de la remise :",
    placeholderPercentage: "Ex : 10",
    placeholderFixed: "Ex : 50.00",
    helpPercentage:
      "Saisissez une valeur entre 1 et 100 pour le pourcentage de remise",
    helpFixed: "Saisissez le montant fixe en euros à déduire du total",
    previewTitle: "Aperçu :",
    previewPercentage: "Une remise de {value}% sera appliquée aux réservations directes",
    previewFixed: "Une remise de {value} € sera appliquée aux réservations directes",
  },

  buttons: {
    saveChanges: "Enregistrer les modifications",
  },
};
